module.exports = __webpack_public_path__ + "img/slideset-text_inactive.ed545ba0.svg";